import { GETURGENTCLIENTORDERLIST_TYPES } from '../actions/getUrgentClientOrderList'
import reducer, { defaultState } from './requests'
const Reducer = (state = defaultState, action) => {
    let requestReducer = reducer(GETURGENTCLIENTORDERLIST_TYPES)(state, action)
    if (requestReducer !== null) return requestReducer
    switch (action.type) {
        default:
            return state
    }
}
export default Reducer
